export const fileTypes = {
  PROMPT: "prompt",
  DATASET: "dataset",
  TEST: "test",
  TEST_SUITE: "test_suite",
  FOLDER: "folder",
  CHAT: "chat",
  EVAL: "eval",
};
